// extracted by mini-css-extract-plugin
export default {"your_rd":"St","title":"Tt","subtitle":"Ut","rd_bio_wrapper":"Vt","rd_text_mobile":"Wt","rd_bio":"Xt","img":"Yt","rd_info":"Zt","rd_name":"au","rd_stat":"bu","rd_text":"cu","btn_mobile":"eu"};
    if(module.hot) {
      // 1711717530880
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  